import { renderToolbar_unstable } from '@fluentui/react-toolbar';

/**
 * Renders the final JSX of the Toolbar component, given the state and context values.
 */
export const renderToolbar = renderToolbar_unstable;
